// API path builders. All paths are RELATIVE (same-origin).
// Host nginx routes /api/parler/* and /api/parlerbot/* to the right backend.
// No CORS, no per-env build-args, no baked origins.

const VERSION_PREFIX = '/v1';

function join(base, path) {
  const tail = String(path == null ? '' : path);
  if (!tail) return base;
  return tail.startsWith('/') ? `${base}${tail}` : `${base}/${tail}`;
}

// Same-origin relative paths — host nginx routes these to the right backend.
export function parlerApiPath(path = '') {
  const tail = String(path == null ? '' : path);
  const fullPath = `${VERSION_PREFIX}${tail.startsWith('/') ? tail : `/${tail}`}`;
  return join('/api/parler', fullPath);
}

export function parlerbotApiPath(path = '') {
  const tail = String(path == null ? '' : path);
  const fullPath = `${VERSION_PREFIX}${tail.startsWith('/') ? tail : `/${tail}`}`;
  return join('/api/parlerbot', fullPath);
}

/**
 * Browser-safe Parlerbot proxy path (same-origin).
 * Use this for fetch() calls in the browser.
 */
export function parlerbotProxyV1(path = '') {
  return parlerbotApiPath(path);
}
